module.exports = __webpack_public_path__ + "category.abe95da9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/profile/category.png
// module id = 2241
// module chunks = 0